<template>
  <div class="text -t2" v-html="parsedText"/>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    props: {
      text: String
    },
    computed: {
      ...mapState(['home']),
      parsedText() {
        if (!this.home) {
          return this.text;
        }
        let text = this.text.replace('[[home-slug]]', this.home.slug);
        text = text.replace('[[home-name]]', this.home.name);

        return text
      },
    }
  }
</script>

<style lang="scss" scoped>
  .text {
    margin-bottom: .75em;
    &::v-deep {
      p {
        margin-bottom: .75em;
        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
